import { FormControl, InputLabel, MenuItem, Select, Theme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core";
import type { ISpecDetails } from "../../../../service/ProductService";
import React, { useState } from "react";
import { Row } from "legacy-components/responsive-grid/ResponsiveGrid";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export interface EventsSpecReferenceProps {
  redocServerUrl: string;
  specDetails: ISpecDetails;
  productName: string;
  specUrl: string;
}

const usIframeStyle = makeStyles((theme: Theme) =>
  createStyles({
    iframe: {
      minHeight: "calc(60vh - 20px)",
    },
  })
);

export const EventsSpecReference: React.FC<EventsSpecReferenceProps> = ({
  specUrl,
  specDetails,
  productName,
}) => {
  const classes = usIframeStyle();
  const identityEnvironment = useSelector((state: any) => state?.common?.identityEnvironment ?? "trimble-pre-prod");

  const  access_token = useSelector((state: any) => state.auth?.user?.access_token);

  const [specLoadingUrl, setSpecLoadingUrl] = useState<string>("");

  const [specEnv, setSpecEnv] = React.useState('prod');


  useEffect(() => {
    if(!identityEnvironment || identityEnvironment === specEnv) {
      return;
    }
    setSpecEnv(identityEnvironment);
  },[identityEnvironment]);

 

  useEffect(() => {
    if(specDetails.preProd || specDetails.prod) {
      let url = "";

      if(specEnv === "preProd") {
        if(specDetails?.preProd) {
          url += `${specDetails?.preProd?.fileName}&access_token=${access_token}`;
        }
      } else {
        if(specDetails?.prod) {
          url += `${specDetails?.prod?.fileName}&access_token=${access_token}`;
        }
      }
     
      url = encodeURI(url);
      setSpecLoadingUrl("?spec=" + url)
    }
  }, [specEnv, access_token])


  return (

    <Row>
      <iframe
        frameBorder="0"
        title="Swagger API Reference"
        height="60vh"
        width="100%"
        className={classes.iframe}
        src={`${specUrl}${specLoadingUrl}`}
      ></iframe>
    </Row>
  );
};

export default React.memo(EventsSpecReference);

